class HonbunStepFlow {
  constructor() {
    this.roots = document.querySelectorAll('.js-honbun-step-flow-root');
    if (!this.roots.length) {
      return;
    }
    this.mq = window.matchMedia('(max-width: 767px)');
    this.swipers = new WeakMap();
    this.refresh = this.refresh.bind(this);
    this.mq.addEventListener('change', this.refresh);
    this.roots.forEach((root) => this.mount(root));
  }

  mount(root) {
    this.destroy(root);
    if (!this.mq.matches) {
      return;
    }
    const el = root.querySelector('.js-honbun-step-swiper');
    if (!el) {
      return;
    }
    const slideCount = el.querySelectorAll('.swiper-slide').length;
    if (slideCount < 2) {
      return;
    }
    const prev = root.querySelector('.js-honbun-step-prev');
    const next = root.querySelector('.js-honbun-step-next');
    const swiper = new Swiper(el, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 16,
      speed: 450,
      watchOverflow: true,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
    });
    this.swipers.set(root, swiper);
  }

  destroy(root) {
    const s = this.swipers.get(root);
    if (s) {
      s.destroy(true, true);
      this.swipers.delete(root);
    }
  }

  refresh() {
    this.roots.forEach((root) => this.mount(root));
  }
}
